import { theme } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectFloors } from 'reduxStore/floors/selectors';
import { selectSites } from 'reduxStore/sites/selectors';
import { Flex } from 'zui/Antd';
import { StyledSitesMenu } from './styles';

const SiteSidebar = ({ selectedSite, setSelectedSite }) => {
	const {
		token: { colorTextSecondary }
	} = theme.useToken();

	const filteredSites = useSelector(selectSites);
	const floors = useSelector(selectFloors);

	const [openKeys, setOpenKeys] = useState([]);

	// build items so that the label for each site is a <div> with its own onClick
	const generateMenuItems = () =>
		filteredSites
			.map((site) => {
				const siteKey = String(site.siteID);
				const siteFloors = floors.filter((f) => f.siteID === site.siteID);

				// 1️⃣ Compute children first
				const children =
					siteFloors.length > 0
						? siteFloors.map((floor) => ({
								key: `${siteKey}-floor-${floor.floorID}`,
								label: <div>{floor.name}</div>
							}))
						: [
								{
									key: `${siteKey}-no-floors`,
									disabled: true,
									label: (
										<div
											style={{
												color: colorTextSecondary,
												fontStyle: 'italic'
											}}
										>
											No floors found
										</div>
									)
								}
							];

				// 2️⃣ Now return your menu item object
				return {
					key: siteKey,
					label: <div style={{ width: '100%' }}>{site.name}</div>,
					children
				};
			})
			.filter(Boolean);

	const menuItems = generateMenuItems();

	useEffect(() => {
		if (menuItems.length && selectedSite == null) {
			setSelectedSite(menuItems[0].key);
			setOpenKeys([menuItems[0].key]);
		}
	}, [menuItems, selectedSite, setSelectedSite]);

	const onOpenChange = (keys) => {
		const latest = keys.find((k) => !openKeys.includes(k));
		if (latest) {
			setOpenKeys([latest]);
			setSelectedSite(parseInt(latest));
		} else {
			setOpenKeys([]);
		}
	};

	return (
		<Flex>
			{menuItems.length > 0 ? (
				<StyledSitesMenu
					mode='inline'
					items={menuItems}
					selectedKeys={[String(selectedSite)]}
					openKeys={openKeys}
					onOpenChange={onOpenChange}
				/>
			) : (
				<div style={{ padding: '0 16px', color: colorTextSecondary }}>No sites found.</div>
			)}
		</Flex>
	);
};

export default SiteSidebar;
